export function typeIgnorantIncludes<T extends U, U>(array: ReadonlyArray<T>, el: U): el is T {
  return array.includes(el as T)
}
